import React, { Component } from 'react';
import { Modal, message, Popconfirm, Button,Icon,Input,Select,Radio ,Space } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import UploadFile from '../../common/UploadFile';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComTable from '../ComTable';

const RadioGroup = Radio.Group;
const confirm = Modal.confirm;
const { Option } = Select;

class UpdateClinicalTrialExp extends Component {
    state = {
        config: [],
        record: {},
        visible: false,
        approvalShow:false,
        approvalHandleShow:false,
        // approvalData:{
        //     approvalStatus:null,
        //     theReasonForRefusal:''
        // },
        vitaeId:null,
        approvalStatus:null,
        theReasonForRefusal:null,
        loading: false,
        UploadProps:{},
        fileList:[],
        pagination: {
            offset: 1,
            pageSize: 5,
        },
        resumeName:null,
        auditState:null,
        relateId:null,
    }

    componentDidMount() {
        const { canEdit,isChinese,userId,vitaeName } = this.props;
        const myuserId=sessionStorage.userId
        const timestamp = Date.now();
        const UploadProps = {
            data:{
                userId,
                path:timestamp
            },
            accept:'.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            action: API_URL.personal.uploadVitae,
            headers: {xToken},
            fileList:[],
        };
        const config = [{
            title: '序号',
            key: 'index',   
            width: 60,
        }, {
            title: '简历名称',
            key: 'vitaeName',
            render: (vitaeName,record) => {
                const { createType } = record;
                return (
                    <div>
                        {vitaeName}
                        <span>{(createType == 'UPLOAD_DOCX' || createType == 'UPLOAD_PDF' )?<Icon style={{ padding:'0 5px',color:'#ff9900'}} type="cloud-upload" />:''}</span>
                    </div>
                )
            }
        }, {
            title: '生成/存档日期',
            key: 'createTime',
            width: 120,
            render: text => text ? text.slice(0, 10) : '',
        }, 
        {
            title: '生成/存档人员',
            key: 'createUserCompellation',
            width: 120,
        },{
            title: '审批状态',
            key: 'approvalStatusShow',
            width: 120,
            render:(text,row)=>{
                const { approvalStatusShow} = row;
                return(
                    <span>{
                        (approvalStatusShow == '-' || approvalStatusShow == '待审批')?<span>{approvalStatusShow}</span>:
                        (<span>
                            <a onClick={this.approvalStatusShow(row)}>{approvalStatusShow}</a>
                        </span>
                        )}</span>
                )
            }
        },{
            title: '操作',
            key: 'operate',
            width: 250,
            render: (text, row) => {
                const { vitaeId,createType,approvalStatus} = row;
                return (
                    <span style={{color:'#b5b5b5'}}>
                        {
                            (approvalStatus=='WAITE')&& (myuserId != userId) &&  canEdit && (<span>
                                <a onClick={this.approvalHandleShow(vitaeId)}>审批</a>
                                <span className="ant-divider" />
                            </span>)
                            
                        }
                        {
                            (((createType == 'UPLOAD_DOCX'||createType == 'GENERATE'||createType == 'CRC_USED_TO_BE_PM')&&(approvalStatus=='EMPTY' || approvalStatus=='AGREE'))||((approvalStatus=='WAITE')&& (myuserId != userId)) || (approvalStatus=='EMPTY' &&createType == 'CRC_USED_TO_BE_PM') )?<a onClick={() => this.download({ vitaeId, typeName: 'DOCX' })}>下载Word文件</a>:<span>下载Word文件</span>
                        }
                        <span className="ant-divider" />
                        {
                            (((createType == 'UPLOAD_PDF'||createType == 'UPLOAD_DOCX'||createType == 'GENERATE'||createType == 'CRC_USED_TO_BE_PM')&&(approvalStatus=='EMPTY' || approvalStatus=='AGREE')) || ((approvalStatus=='WAITE')&& (myuserId != userId)) || (approvalStatus=='EMPTY' &&createType == 'CRC_USED_TO_BE_PM') )?<a onClick={() => this.download({vitaeId, typeName: 'PDF' })}>下载PDF文件</a>:<span>下载PDF文件</span>
                        }
                        {
                            canEdit &&
                            <span>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(vitaeId)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        }
                    </span>
                );
            }
        }];
        if(vitaeName){
            this.setState({ config,UploadProps,resumeName:vitaeName }, () => {
                this.loadData();
            });
        }else{
            this.setState({ config,UploadProps }, () => {
                this.loadData();
            });
        }
        
    }

    approvalStatusShow(row){
        return ()=>{
            const { vitaeId,createType,approvalStatus,vitaeApprovalLog } = row;
            const {operateDate,operateUserCompellation,operateUserEmployeeCode,rejectReason} = vitaeApprovalLog
            Modal.info({
                iconType:'',
                okText:'知道了',
                content:(
                    <div style={{fontSize:'14px'}}>
                        {approvalStatus=='AGREE'?<p><span style={{fontWeight:'700'}}>审批通过时间：</span>{operateDate}</p>:<p><span style={{fontWeight:'700'}}>审批不通过原因：</span>{rejectReason}</p>}
                        <p><span style={{fontWeight:'700'}}>审批人：</span>{operateUserCompellation+'['+operateUserEmployeeCode+']'}</p>
                    </div>
                )
            })
        }
    }
    approvalHandleShow = (id) => {
        return ()=>{
            this.setState({approvalHandleShow:true,vitaeId:id})
        }
    };
    approvalHandle = ()=>{
        const { approvalStatus,theReasonForRefusal,vitaeId} = this.state
        if(!approvalStatus){
            message.error('请选择审批结果！');
            return
        }else if( approvalStatus ==='REJECT' && !theReasonForRefusal){
            message.error('请填写审批不通过原因！');
            return
        }else{
            const options = {
                method: 'POST',
                url: API_URL.user.approvalVitae,
                data: {
                    vitaeId,
                    approvalStatus,
                    rejectReason: theReasonForRefusal,
                },
                dataType: 'json',
                doneResult: res => {
                    if(res.result=='success'){
                        this.loadData();
                        message.success('审批成功！');
                        this.setState({approvalHandleShow:false});
                    }
                },
            };
            $.sendRequest(options);
        }
        
    }

    onChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else if (file.response.success) {
                this.setState({ loading: false,fileList:[] }, () => {
                    this.loadData();
                });
            }
        }
    }

    show = (resumeName,relateId) => {
        this.setState({
            resumeName,
            relateId,
            visible: true,
            pagination: {
                offset: 1,
                pageSize: 5,
            },
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination,resumeName,auditState,relateId } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeListByUserId,
            data: {
                userId,
                vitaeId:relateId,
                offset: current,
                limit: pageSize,
                typeName: isChinese ? 'CHINESE' : 'ENGLISH',
                vitaeName:resumeName,
                approvalStatus:auditState
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data,
                    relateId:null
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    download = (params) => {
        ExportUtil.export(params, null, API_URL.personal.downloadVitaeByType);
        message.success('正在下载中!')
    }

    delete = (vitaeId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.deleteVitaeByVitaeId,
            data: { vitaeId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    render() {
        const { canEdit ,isChinese } = this.props;
        const { data, config, loading, visible, pagination,UploadProps,resumeName,auditState,approvalHandleShow,approvalStatus,theReasonForRefusal } = this.state;
        return (
            <Modal
                title="简历中心"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                footer={<Button onClick={this.hide}>关闭</Button>}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width={1000}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <div className='modal-file-button' style={{paddingBottom: '10px',display:'flex',width:'100%' }}>
                        <div style={{marginRight:'20px' }}>
                            <label className="ui-label" style={{ paddingRight: '20px' }}>简历名称</label>
                            <Input
                                placeholder="请输入"
                                style={{ width: 150 }}
                                value={resumeName}
                                onChange={e=>{this.setState({resumeName:e.target.value})}}
                            />
                            </div>
                            <div style={{marginRight:'20px' }}>
                                <label className="ui-label" style={{ paddingRight: '20px' }}>审批状态</label>
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 100 }}
                                    allowClear={true}
                                    onChange={(value)=>{this.setState({auditState:value})}}
                                >
                                    <Option value="EMPTY">-</Option>
                                    <Option value="WAITE">待审批</Option>
                                    <Option value="AGREE">审批通过</Option>
                                    <Option value="REJECT">审批不通过</Option>
                                </Select>
                            </div>
                            <div>
                                <Button type="primary" onClick={this.loadData}>搜索</Button>
                            </div>
                            {canEdit && <div style={{ marginLeft:'350px'}}>
                                <UploadFile
                                    data={{
                                        ...UploadProps.data,
                                        typeName: isChinese ? 'CHINESE' : 'ENGLISH',
                                    }}
                                    accept={UploadProps.accept}
                                    onChange={this.onChange}
                                    uploadUrl={UploadProps.action}
                                    showUploadList={false}
                                >
                                    <Button type="primary">存档</Button>
                                </UploadFile>
                            </div>}
                        </div>
                        <ComTable
                            data={data}
                            config={config}
                            loading={loading}
                            pagination={pagination}
                            onChange={(params) => this.handleTableChange(params)}
                        />
                        <Modal
                            visible={approvalHandleShow}
                            className="creat-modal EditPersonModal"
                            wrapClassName="vertical-center-modal"
                            maskClosable={false}
                            width="420px"
                            onOk={this.approvalHandle} 
                            onCancel={()=>{this.setState({approvalHandleShow:false})}}
                        >
{/* <<<<<<< HEAD
                            <div style={{padding:'10px 20px'}}>
                            <div style={{fontSize:'16px',fontWeight:'700',lineHeight:'35px'}}>是否审批通过？</div>
                            <RadioGroup onChange={(e)=>{ this.setState({approvalStatus:e.target.value})}} value={approvalStatus} >
                                <Radio style={{display:'block',margin:'10px 0 10px 20px'}} value={'AGREE'}>审批通过</Radio>
                                <Radio style={{display:'block',margin:'0 0 10px 20px'}} value={'REJECT'}>审批不通过</Radio>
                            </RadioGroup>
                            <Input
                                placeholder="请输入不通过原因"
                                value={theReasonForRefusal}
                                onChange={e=>{this.setState({theReasonForRefusal:e.target.value})}}
                                style={{width:'230px',display:approvalStatus=='REJECT'?'block':'none',marginLeft:'20px'}}
                            />
                        </div>
                    </Modal>
======= */}
                            <div style={{ padding: '10px 20px' }}>
                            <div style={{fontSize:'18px',fontWeight:'700'}}>是否审批通过</div>
                                <RadioGroup style={{ width: '200px', margin: '20px', display: 'flex', justifyContent: 'space-between' }} onChange={(e)=>{ this.setState({approvalStatus:e.target.value})}} value={approvalStatus} >
                                    <Radio value={'AGREE'}>审批通过</Radio>
                                    <Radio value={'REJECT'}>审批不通过</Radio>
                                </RadioGroup>
                                <Input
                                    placeholder="请输入不通过原因"
                                    value={theReasonForRefusal}
                                    onChange={e=>{this.setState({theReasonForRefusal:e.target.value})}}
                                    style={{width:'300px',display:approvalStatus=='REJECT'?'block':'none',marginLeft:'20px'}}
                                />
                            </div>
                        </Modal>
                </div>
            </Modal>
            
        )
    }
}

export default UpdateClinicalTrialExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/CurriculumVitaeCenter.js